<template>
  <div v-if="data">
    <UiModal 
      :open="status_show_popup_give_name" 
      @close="status_show_popup_give_name = false"
      >
      <div class="p-5">

        <h4 class="text-center mb-5" style="line-height: 1.5em;">
          {{lg('',{
            en: 'Name Your Foal',
            zh: '',
          })}}
        </h4>

        <horseItem
          :data="data"
          :cfg_hide_more="true"
        />

        <div class="py-4">
          <div class="d-flex align-items-center mb-4">
            <div class="text-small op4" style="width: 60%;">
              {{lg('',{
                en: 'ENTER NAME',
                zh: '',
              })}}
            </div>

            <input 
              v-model.trim="form.name" 
              type="text" 
              class="form-control"
              style="width: 40%;"
            >
          </div>

          <div class="mt-5 row">

            <div class="col-6">
              <span 
                @click="status_show_popup_give_name = false"
                class="btn btn-outline-primary w-100"
                >
                {{lg('',{
                  en: 'Cancel',
                  zh: '',
                })}}
              </span>
            </div>
            <div class="col-6">
              <span 
                @click="actionGiveName()"
                class="btn btn-primary w-100"
                >
                {{lg('',{
                  en: 'Confirm',
                  zh: '',
                })}}
              </span>
            </div>
          </div>
        </div>
      </div>
    </UiModal>
  </div>
</template>

<script>
import {mapActions} from 'vuex'
import horseItem from '../_cp_busi/horse_item.vue'

export default {
  name: 'popupGiveName',
  components: {
    horseItem,
  },
  props: [],
  data() {
    return {
      status_show_popup_give_name: false,

      form: {
        name: '',
      },
    }
  },
  computed: {
    data(){
      return this.$store.state.dataBus.data_on_give_name
    },

    address_my(){
      return this.$store.state.web3.account
    },
  },
  watch: {
    data(val){
      if(val){
        this.popupShow()
      }
      else{
        this.status_show_popup_give_name = false
        this.clearForm()
      }
    },
    'status_show_popup_give_name'(val){
      if(!val){
        this.$store.commit('setDataBusKey',{
          data_on_give_name: null,
        })
      }
    },
  },
  methods: {
    ...mapActions([
      'setHorseName',
    ]),
    clearForm(){
      this.form.name = ''
    },
    popupHide(){
      this.clearForm()
      this.status_show_popup_give_name = false
    },
    popupShow(){
      this.status_show_popup_give_name = true
    },
    async actionGiveName(){
      let v = this

      if(!this.form.name){
        return
      }

      await v.setHorseName({
        address_my: this.address_my,
        name: this.form.name,
        horse_data: JSON.parse(JSON.stringify(this.data)),
      })

      v.popupHide()
    },
  },
  created() {
    return
  },
  //mounted() {},
  //beforeDestroy() {},
  //update() {},
  //activited() {},
  //beforeRouteUpdate() {},
  //filters: {},
};
</script>

<style lang="scss" scoped>
  
</style>